import http from './http-common'

export const getSubclassByActive = (idsActives: string) => http.get(`/subclass/active/${idsActives}`)